//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { getDateTimeService } from '@react-bridge/wrappers/ng-service-provider';

export function staticRelativeTime(timestamp, longform) {
  const DateTimeService = getDateTimeService();
  const postMoment = (timestamp._isAMomentObject) ? timestamp : DateTimeService.userMoment(new Date(timestamp));
  const userMoment = DateTimeService.userMoment(new Date());
  const secondsAgo = userMoment.diff(postMoment, 'seconds');
  const secondsPerMinute = 60;
  const secondsPerHour = secondsPerMinute * 60;
  const secondsPerDay = secondsPerHour * 24;
  const secondsPerWeek = secondsPerDay * 7;
  const LONGFORM_DATE_FORMAT = 'MMMM DD, YYYY';
  let formattedTime;
  let diff;

  if (longform) {
    if (secondsAgo < secondsPerMinute) {
      diff = secondsAgo;
      formattedTime = diff + ((diff === 1) ? ' second ago' : ' seconds ago');
    } else if (secondsAgo < secondsPerHour) {
      diff = userMoment.diff(postMoment, 'minutes');
      formattedTime = diff + ((diff === 1) ? ' minute ago' : ' minutes ago');
    } else if (secondsAgo < secondsPerDay) {
      diff = userMoment.diff(postMoment, 'hours');
      formattedTime = diff + ((diff === 1) ? ' hour ago' : ' hours ago');
    } else if (secondsAgo < secondsPerWeek) {
      diff = userMoment.diff(postMoment, 'days');
      formattedTime = diff + ((diff === 1) ? ' day ago' : ' days ago');
    } else {
      formattedTime = postMoment.format(LONGFORM_DATE_FORMAT);
    }
  } else if (secondsAgo < secondsPerMinute) {
    formattedTime = `${secondsAgo}s`;
  } else if (secondsAgo < secondsPerHour) {
    formattedTime = `${userMoment.diff(postMoment, 'minutes')}m`;
  } else if (secondsAgo < secondsPerDay) {
    formattedTime = `${userMoment.diff(postMoment, 'hours')}h`;
  } else if (secondsAgo < secondsPerWeek) {
    formattedTime = `${userMoment.diff(postMoment, 'days')}d`;
  } else {
    formattedTime = `${userMoment.diff(postMoment, 'weeks')}w`;
  }

  return formattedTime;
}
